import { z } from 'zod';
import { socialVideoFormatSchema } from '../social-video-format-schema';

export const generateSocialVideoV1RequestSchema = z.object({
  clipIds: z.array(z.number()).optional(),
  format: socialVideoFormatSchema.optional().default('vertical'),
});

export type IGenerateSocialVideoV1Request = z.infer<typeof generateSocialVideoV1RequestSchema>;
